import React from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import {
  AuCallout,
  AuFormItemWrapper,
  AuControlInput,
  AuTextInput,
  AuDateInput,
  AuSelect,
  AuErrorText
} from 'components/DTA';
import { STATES } from 'arnConstants';

const MarriageCertificateDetails: React.FC = () => {
  const { errors } = useFormikContext();
  const declarationFieldError = get(errors, 'marriageCertificateDetails.declaration');

  return (
    <>
      <AuFormItemWrapper>
        <AuCallout >
          While most Australian marriage certificates can be verified online, formats and required data for marriage
          certificates varies greatly by date and state / territory. Guidance on finding and entering the correct
          data for marriage certificates can be found on
          the <a href="https://www.humanservices.gov.au/organisations/health-professionals/enablers/verify-your-identity-proda-your-marriage-certificate/34771" target="_blank" rel="noopener noreferrer">Human Services website</a>.
        </AuCallout>
      </AuFormItemWrapper>

      <AuTextInput
        name='marriageCertificateDetails.firstPersonGivenNames'
        label='Given names of first person on certificate'
        as='input'
        block />
      <AuTextInput
        name='marriageCertificateDetails.firstPersonFamilyName'
        label='Family name of first person on certificate'
        as='input'
        block />
      <AuTextInput
        name='marriageCertificateDetails.secondPersonGivenNames'
        label='Given names of second person on certificate'
        as='input'
        block />
      <AuTextInput
        name='marriageCertificateDetails.secondPersonFamilyName'
        label='Family name of second person on certificate'
        as='input'
        block />
      <AuDateInput
        name='marriageCertificateDetails.dateOfMarriage'
        label='Date of marriage'
        hintText='For example, 31 01 1980' />
      <AuSelect
        name={'marriageCertificateDetails.registrationState'}
        label='Registration state or territory'
        block
        options={[
          {
            text: 'Please select',
            value: ''
          },
          ...STATES.map((state: { name: string; code: string; }) => {
            return {
              text: state.name,
              value: state.code
            };
          })
        ]} />
      <AuTextInput
        name='marriageCertificateDetails.registrationNumber'
        label='Registration number'
        as='input'
        block />
      <AuDateInput
        name='marriageCertificateDetails.registrationDate'
        label='Registration date'
        hintText='For example, 31 01 2010' />
      <AuTextInput
        name='marriageCertificateDetails.certificateNumber'
        label='Certificate number'
        as='input'
        block />
      <AuDateInput
        name='marriageCertificateDetails.certificateIssueDate'
        label='Certificate issue date'
        hintText='For example, 31 01 2010' />
      <AuFormItemWrapper>
        <AuCallout title='' style={{ paddingTop: '0' }}>
          <AuControlInput
            name='marriageCertificateDetails.declaration'
            id='checkbox-marriageCertificateDetails-declaration'
            label=''
            type='checkbox'
            hintText='I confirm that I am authorised to provide the personal details
             presented and I consent to my information being checked with the document
             issuer or official record holder via third party systems for the purpose of confirming my identity'
          />
          {declarationFieldError && <AuErrorText text={declarationFieldError} />}
        </AuCallout>
      </AuFormItemWrapper>
    </>
  );
};

export default MarriageCertificateDetails;